import Spinner from '../Spinner';
import styles from './Button.module.css';

const Button = ({ text, type, isFetching }) => {
  const textVisibility = isFetching
    ? { visibility: 'hidden' }
    : { visibility: 'visible' };

  return (
    <button type={type} className={styles.btn}>
      <span className={styles.text} style={textVisibility}>
        {text}
      </span>
      {isFetching && (
        <Spinner
          containerClass={styles.spinnerContainer}
          spinnerClass={styles.spinner}
        />
      )}
    </button>
  );
};

Button.defaultProps = {
  type: 'button',
};

export default Button;
